import { athensStamp, athensStampLong, SENT_EMAIL_LABELS, SENT_EMAIL_STATE_LABELS, type SentEmail } from "../../shared/sent-emails";

/** What has gone to the client for this card. Read-only. */
export function SentEmails({ emails, step }: { emails: SentEmail[]; step: number }) {
  const here = emails.filter((item) => item.step === step);
  return (
    <section className="panel sent-emails" aria-label="Email προς τον πελάτη">
      <div className="sent-emails-head">
        <h2>Email προς τον πελάτη</h2>
        {here.length ? (
          <p className="sent-emails-here">
            {here.map((item, index) => (
              <span key={`${item.kind}-${index}`} className={`mail-chip ${item.state}`}>
                ✉ {SENT_EMAIL_LABELS[item.kind]} · {SENT_EMAIL_STATE_LABELS[item.state]} {athensStamp(item.at)}
              </span>
            ))}
          </p>
        ) : null}
      </div>
      {emails.length === 0 ? (
        <p className="sent-emails-empty">Δεν έχει φύγει ακόμα κανένα email σε αυτόν τον πελάτη.</p>
      ) : (
        <ul className="sent-emails-list">
          {emails.map((item, index) => (
            <li key={`${item.kind}-${item.at}-${index}`} className={item.step === step ? "current" : undefined}>
              <div className="sent-email-main">
                <strong>{SENT_EMAIL_LABELS[item.kind]}</strong>
                <span className={`mail-state ${item.state}`}>{SENT_EMAIL_STATE_LABELS[item.state]}</span>
                <span className="sent-email-step">Βήμα {item.step}/4</span>
              </div>
              <div className="sent-email-meta">
                <time dateTime={item.at}>{athensStampLong(item.at)}</time>
                <span>{item.recipients.length ? item.recipients.join(", ") : "χωρίς παραλήπτη"}</span>
                {item.note ? <span>{item.note}</span> : null}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
